import { useMutation } from 'react-query';
import { network } from 'services/network';

const extractRowsBoardToXls = (params) => {
    return network
        .post(
            'api/bo/extractBattleCardToXls',
            { filterRquest: params.filter, configRequest: params.configRequest },
            {
                responseType: 'blob',
            },
        )
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${params.fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            return true;
        })
        .catch((error) => {
            throw error;
        });
};
export const useMutationRowsBoardToXls = () => {
    return useMutation<unknown, QueryError, IUseMutationRowsBoardToXlsPayload>((params) =>
        extractRowsBoardToXls(params),
    );
};

interface IUseMutationRowsBoardToXlsPayload {
    fileName: string;
    filter: any;
    configRequest: {
        contractId: number;
        isExtractRemainingDuration: boolean;
        isExtractPercentageComplete: boolean;
        userData: string;
    };
}
